import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Alert, Card } from 'react-bootstrap'
import Title from "../../../utilities/other/title"

function Medical_Notes(props){
    const [localNotes, setLocalNotes] = useState('')
    const [hasChanges, setHasChanges] = useState(false)
    const [showSaved, setShowSaved] = useState(false)
    const [isFocused, setIsFocused] = useState(false)

    useEffect(() => {
        setLocalNotes(props.data?.medical_notes || '')
    }, [props.data?.medical_notes])

    const handleLocalChange = (event) => {
        setLocalNotes(event.target.value)
        setHasChanges(true)
        setShowSaved(false)
    }

    const handleSave = () => {
        const event = {
            target: {
                name: 'medical_notes',
                value: localNotes
            }
        }
        props.handler("medical_notes", event)
        setHasChanges(false)
        setShowSaved(true)
        
        setTimeout(() => setShowSaved(false), 3000)
    }

    const handleCancel = () => {
        setLocalNotes(props.data?.medical_notes || '')
        setHasChanges(false)
        setShowSaved(false)
    }

    return(
        <Container fluid style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', padding: '40px 20px' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                
                {/* Header Section */}
                <div style={{ 
                    marginBottom: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div>
                        <h2 style={{ 
                            fontSize: '28px', 
                            fontWeight: '600',
                            color: '#2c3e50',
                            marginBottom: '5px'
                        }}>
                            Medical Notes
                        </h2>
                        <p style={{ 
                            color: '#6c757d', 
                            fontSize: '14px',
                            margin: 0 
                        }}>
                            Document clinical observations
                        </p>
                    </div>
                    
                    {hasChanges && (
                        <div style={{
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '20px',
                            padding: '8px 16px',
                            fontSize: '13px',
                            color: '#856404',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}>
                            <span style={{ 
                                width: '8px', 
                                height: '8px', 
                                backgroundColor: '#ffc107',
                                borderRadius: '50%',
                                display: 'inline-block'
                            }}></span>
                            Unsaved Changes
                        </div>
                    )}
                </div>

                {/* Success Message */}
                {showSaved && (
                    <Alert 
                        variant="success" 
                        dismissible 
                        onClose={() => setShowSaved(false)}
                        style={{
                            borderRadius: '10px',
                            border: 'none',
                            boxShadow: '0 2px 8px rgba(40, 167, 69, 0.15)'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <circle cx="10" cy="10" r="10" fill="#28a745"/>
                                <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <strong>Changes saved successfully!</strong>
                        </div>
                    </Alert>
                )}

                {/* Main Card */}
                <Card style={{ 
                    border: isFocused ? '2px solid #007bff' : '2px solid #dee2e6',
                    borderRadius: '12px',
                    boxShadow: isFocused 
                        ? '0 0 0 4px rgba(0, 123, 255, 0.1), 0 4px 6px rgba(0, 0, 0, 0.07)' 
                        : '0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06)',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease-in-out'
                }}>
                    <Card.Body style={{ padding: '0' }}>
                        <Form.Control
                            as="textarea"
                            value={localNotes}
                            onChange={handleLocalChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            disabled={props.disabled}
                            placeholder="Enter clinical notes here..."


                            style={{
                                fontSize: '15px',
                                lineHeight: '1.8',
                                border: 'none',
                                outline: 'none',
                                padding: '30px',
                                resize: 'vertical',
                                minHeight: '500px',
                                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                                backgroundColor: props.disabled ? '#f8f9fa' : '#fff',
                                boxShadow: 'none'
                            }}
                        />
                    </Card.Body>
                    
                    {/* Footer */}
                    <div style={{
                        padding: '20px 30px',
                        backgroundColor: '#f8f9fa',
                        borderTop: '1px solid #e9ecef',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div style={{ 
                            fontSize: '13px', 
                            color: '#6c757d',
                            display: 'flex',
                            gap: '20px',
                            alignItems: 'center'
                        }}>
                            <span>
                                <strong>{localNotes.length}</strong> characters
                            </span>
                            {localNotes.split('\n').length > 1 && (
                                <span>
                                    <strong>{localNotes.split('\n').length}</strong> lines
                                </span>
                            )}
                        </div>
                        
                        <div style={{ display: 'flex', gap: '10px' }}>
                            {hasChanges && (
                                <Button 
                                    variant="outline-secondary" 
                                    onClick={handleCancel}
                                    disabled={props.disabled}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '8px 20px',
                                        fontWeight: '500',
                                        fontSize: '14px',
                                        border: '2px solid #dee2e6',
                                        backgroundColor: 'white'
                                    }}
                                >
                                    Cancel
                                </Button>
                            )}
                            <Button 
                                variant={hasChanges ? "primary" : "success"}
                                onClick={handleSave}
                                disabled={props.disabled || !hasChanges}
                                style={{
                                    borderRadius: '8px',
                                    padding: '8px 24px',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    minWidth: '130px',
                                    border: 'none',
                                    backgroundColor: hasChanges ? '#007bff' : '#28a745',
                                    boxShadow: hasChanges ? '0 2px 4px rgba(0, 123, 255, 0.3)' : 'none',
                                    cursor: props.disabled || !hasChanges ? 'not-allowed' : 'pointer',
                                    opacity: props.disabled || !hasChanges ? 0.6 : 1
                                }}
                            >
                                {hasChanges ? (
                                    <>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="white" style={{ marginRight: '6px', verticalAlign: 'text-top' }}>
                                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                        </svg>
                                        Save Changes
                                    </>
                                ) : (
                                    <>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="white" style={{ marginRight: '6px', verticalAlign: 'text-top' }}>
                                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                                        </svg>
                                        Saved
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </Card>
            </div>

            <style jsx>{`
                textarea:focus {
                    outline: none !important;
                    box-shadow: none !important;
                    border: none !important;
                }
            `}</style>
        </Container>
    )
}

export default Medical_Notes;